import moment from "moment";

export const authData = [{
    title: `1.0 Hotel Managers Situation Report <br/>酒店B2级以上管理层情况报告`,
    value: '/hr/1',
    key: '/hr/1',
    children: [{
        title: '查看',
        key: 'read_1',
    }, {
        title: '编辑',
        key: 'edit_1',
    }]
}, {
    title: `2.0 Hotel Manning Level Report<br/> 酒店人员配置及流动情况报告`,
    value: '/hr/2',
    key: '/hr/2',
    children: [{
        title: '查看',
        key: 'read_2',
    }, {
        title: '编辑',
        key: 'edit_2',
    }]
}, {
    title: `3.0 Hotel Post Vacancy Report <br/>酒店B2级以上空缺职位报告`,
    value: '/hr/3',
    key: '/hr/3',
    children: [{
        title: '查看',
        key: 'read_3',
    }, {
        title: '编辑',
        key: 'edit_3',
    }]
}, {
    title: `4.0 Hotel Training Report <br/>酒店培训报告`,
    value: '/hr/4',
    key: '/hr/4',
    children: [{
        title: `4.1 Hotel Training Report 酒店培训报告`,
        value: '/hr/4_1',
        key: '/hr/4_1',
        children: [{
            title: '查看',
            key: 'read_4_1',
        }, {
            title: '编辑',
            key: 'edit_4_1',
        }]
    }, {
        title: "4.2 Dept. Training Records<br/> 部门培训记录汇总",
        value: "/hr/4_2",
        key: "/hr/4_2",
        children: [{
            title: `4.2.1 ADMIN & EO 行政部`,
            value: '/hr/4_2_11',
            key: '/hr/4_2_11',
            children: [{
                title: '查看',
                key: 'read_4_2_11',
            }, {
                title: '编辑',
                key: 'edit_4_2_11',
            }]
        }, {
            title: `4.2.2 HR 部门`,
            value: '/hr/4_2_1',
            key: '/hr/4_2_1',
            children: [{
                title: '查看',
                key: 'read_4_2_1',
            }, {
                title: '编辑',
                key: 'edit_4_2_1',
            }]
        }, {
            title: `4.2.3 FIN 部门`,
            value: '/hr/4_2_2',
            key: '/hr/4_2_2',
            children: [{
                title: '查看',
                key: 'read_4_2_2',
            }, {
                title: '编辑',
                key: 'edit_4_2_2',
            }]
        }, {
            title: `4.2.4 ENG 部门`,
            value: '/hr/4_2_3',
            key: '/hr/4_2_3',
            children: [{
                title: '查看',
                key: 'read_4_2_3',
            }, {
                title: '编辑',
                key: 'edit_4_2_3',
            }]
        }, {
            title: `4.2.5 SEC 部门`,
            value: '/hr/4_2_4',
            key: '/hr/4_2_4',
            children: [{
                title: '查看',
                key: 'read_4_2_4',
            }, {
                title: '编辑',
                key: 'edit_4_2_4',
            }]
        }, {
            title: `4.2.6 FO 部门 `,
            value: '/hr/4_2_5',
            key: '/hr/4_2_5',
            children: [{
                title: '查看',
                key: 'read_4_2_5',
            }, {
                title: '编辑',
                key: 'edit_4_2_5',
            }]
        }, {
            title: `4.2.7 HSKP 部门`,
            value: '/hr/4_2_6',
            key: '/hr/4_2_6',
            children: [{
                title: '查看',
                key: 'read_4_2_6',
            }, {
                title: '编辑',
                key: 'edit_4_2_6',
            }]
        }, {
            title: `4.2.8 F&B 部门`,
            value: '/hr/4_2_7',
            key: '/hr/4_2_7',
            children: [{
                title: '查看',
                key: 'read_4_2_7',
            }, {
                title: '编辑',
                key: 'edit_4_2_7',
            }]
        }, {
            title: `4.2.9 S&M 部门`,
            value: '/hr/4_2_8',
            key: '/hr/4_2_8',
            children: [{
                title: '查看',
                key: 'read_4_2_8',
            }, {
                title: '编辑',
                key: 'edit_4_2_8',
            }]
        }]
    }, {
        title: `4.3 Core Training Programs Records ${moment().format('YYYY')} ${moment().format('YYYY')} 核心课程培训记录`,
        value: '/hr/4_3_1',
        key: '/hr/4_3_1',
        children: [{
            title: '查看',
            key: 'read_4_3_1',
        }, {
            title: '编辑',
            key: 'edit_4_3_1',
        }],
        // children: [{
        //     title: `4.3.1 HR 部门`,
        //     value: '/hr/4_3_1',
        //     key: '/hr/4_3_1',
        //     children: [{
        //         title: '查看',
        //         key: 'read_4_3_1',
        //     }, {
        //         title: '编辑',
        //         key: 'edit_4_3_1',
        //     }]
        // }, {
        //     title: `4.3.2 FIN 部门`,
        //     value: '/hr/4_3_2',
        //     key: '/hr/4_3_2',
        //     children: [{
        //         title: '查看',
        //         key: 'read_4_3_2',
        //     }, {
        //         title: '编辑',
        //         key: 'edit_4_3_2',
        //     }]
        // }, {
        //     title: `4.3.3 ENG 部门`,
        //     value: '/hr/4_3_3',
        //     key: '/hr/4_3_3',
        //     children: [{
        //         title: '查看',
        //         key: 'read_4_3_3',
        //     }, {
        //         title: '编辑',
        //         key: 'edit_4_3_3',
        //     }]
        // }, {
        //     title: `4.3.4 SEC 部门`,
        //     value: '/hr/4_3_4',
        //     key: '/hr/4_3_4',
        //     children: [{
        //         title: '查看',
        //         key: 'read_4_3_4',
        //     }, {
        //         title: '编辑',
        //         key: 'edit_4_3_4',
        //     }]
        // }, {
        //     title: `4.3.5 FO 部门 `,
        //     value: '/hr/4_3_5',
        //     key: '/hr/4_3_5',
        //     children: [{
        //         title: '查看',
        //         key: 'read_4_3_5',
        //     }, {
        //         title: '编辑',
        //         key: 'edit_4_3_5',
        //     }]
        // }, {
        //     title: `4.3.6 HSKP 部门`,
        //     value: '/hr/4_3_6',
        //     key: '/hr/4_3_6',
        //     children: [{
        //         title: '查看',
        //         key: 'read_4_3_6',
        //     }, {
        //         title: '编辑',
        //         key: 'edit_4_3_6',
        //     }]
        // }, {
        //     title: `4.3.7 F&B 部门`,
        //     value: '/hr/4_3_7',
        //     key: '/hr/4_3_7',
        //     children: [{
        //         title: '查看',
        //         key: 'read_4_3_7',
        //     }, {
        //         title: '编辑',
        //         key: 'edit_4_3_7',
        //     }]
        // }, {
        //     title: `4.3.8 S&M 部门`,
        //     value: '/hr/4_3_8',
        //     key: '/hr/4_3_8',
        //     children: [{
        //         title: '查看',
        //         key: 'read_4_3_8',
        //     }, {
        //         title: '编辑',
        //         key: 'edit_4_3_8',
        //     }]
        // }]
    }]
}, {
    title: `5.0 Hotel AL&OT Summary Report<br/> 酒店年假及加班统计报告`,
    value: '/hr/5',
    key: '/hr/5',
    children: [{
        title: '查看',
        key: 'read_5',
    }, {
        title: '编辑',
        key: 'edit_5',
    }]
}, {
    title: `6.0 Hotel PM Report <br/>酒店积极流动率报告`,
    value: '/hr/6',
    key: '/hr/6',
    children: [{
        title: '查看',
        key: 'read_6',
    }, {
        title: '编辑',
        key: 'edit_6',
    }]
}, {
    title: `7.0 Dept.  Training Calendar<br/> 部门培训日历`,
    value: '/hr/7',
    key: '/hr/7',
    children: [{
        title: `7.1 Training Calendar Dept - HOJO <br/>HR组织的酒店公共课`,
        value: '/hr/7_1',
        key: '/hr/7_1',
        children: [{
            title: `7.1.1 HR 部门`,
            value: '/hr/7_1/HR',
            key: '/hr/7_1/HR',
            children: [{
                title: '查看',
                key: 'read_7_1_1',
            }, {
                title: '编辑',
                key: 'edit_7_1_1',
            }]
        }, , {
            title: `7.1.2 FIN 部门`,
            value: '/hr/7_1/FIN',
            key: '/hr/7_1/FIN',
            children: [{
                title: '查看',
                key: 'read_7_1_2',
            }, {
                title: '编辑',
                key: 'edit_7_1_2',
            }]
        }, {
            title: `7.1.3 ENG 部门`,
            value: '/hr/7_1/ENG',
            key: '/hr/7_1/ENG',
            children: [{
                title: '查看',
                key: 'read_7_1_3',
            }, {
                title: '编辑',
                key: 'edit_7_1_3',
            }]
        }, {
            title: `7.1.4 SEC 部门`,
            value: '/hr/7_1/SEC',
            key: '/hr/7_1/SEC',
            children: [{
                title: '查看',
                key: 'read_7_1_4',
            }, {
                title: '编辑',
                key: 'edit_7_1_4',
            }]
        }, {
            title: `7.1.5 FO 部门`,
            value: '/hr/7_1/FO',
            key: '/hr/7_1/FO',
            children: [{
                title: '查看',
                key: 'read_7_1_5',
            }, {
                title: '编辑',
                key: 'edit_7_1_5',
            }]
        }, {
            title: `7.1.6 HSKP 部门`,
            value: '/hr/7_1/HSKP',
            key: '/hr/7_1/HSKP',
            children: [{
                title: '查看',
                key: 'read_7_1_6',
            }, {
                title: '编辑',
                key: 'edit_7_1_6',
            }]
        }, {
            title: `7.1.7 F&B 部门`,
            value: '/hr/7_1/F&B',
            key: '/hr/7_1/F&B',
            children: [{
                title: '查看',
                key: 'read_7_1_7',
            }, {
                title: '编辑',
                key: 'edit_7_1_7',
            }]
        }, {
            title: `7.1.8 S&M 部门`,
            value: '/hr/7_1/S&M',
            key: '/hr/7_1/S&M',
            children: [{
                title: '查看',
                key: 'read_7_1_8',
            }, {
                title: '编辑',
                key: 'edit_7_1_8',
            }]
        }, {
            title: `7.1.9 HR 组织的酒店公共课`,
            value: '/hr/7_1/HRPC',
            key: '/hr/7_1/HRPC',
            children: [{
                title: '查看',
                key: 'read_7_1_9',
            }, {
                title: '编辑',
                key: 'edit_7_1_9',
            }]
        }]
    }, {
        title: `7.2 Training Calendar Dept - WGPR <br/>HR组织的酒店公共课`,
        value: '/hr/7_2',
        key: '/hr/7_2',
        children: [{
            title: `7.2.1 HR 部门`,
            value: '/hr/7_2/HR',
            key: '/hr/7_2/HR',
            children: [{
                title: '查看',
                key: 'read_7_2_1',
            }, {
                title: '编辑',
                key: 'edit_7_2_1',
            }]
        }, , {
            title: `7.2.2 FIN 部门`,
            value: '/hr/7_2/FIN',
            key: '/hr/7_2/FIN',
            children: [{
                title: '查看',
                key: 'read_7_2_2',
            }, {
                title: '编辑',
                key: 'edit_7_2_2',
            }]
        }, {
            title: `7.2.3 ENG 部门`,
            value: '/hr/7_2/ENG',
            key: '/hr/7_2/ENG',
            children: [{
                title: '查看',
                key: 'read_7_2_3',
            }, {
                title: '编辑',
                key: 'edit_7_2_3',
            }]
        }, {
            title: `7.2.4 SEC 部门`,
            value: '/hr/7_2/SEC',
            key: '/hr/7_2/SEC',
            children: [{
                title: '查看',
                key: 'read_7_2_4',
            }, {
                title: '编辑',
                key: 'edit_7_2_4',
            }]
        }, {
            title: `7.2.5 FO 部门`,
            value: '/hr/7_2/FO',
            key: '/hr/7_2/FO',
            children: [{
                title: '查看',
                key: 'read_7_2_5',
            }, {
                title: '编辑',
                key: 'edit_7_2_5',
            }]
        }, {
            title: `7.2.6 HSKP 部门`,
            value: '/hr/7_2/HSKP',
            key: '/hr/7_2/HSKP',
            children: [{
                title: '查看',
                key: 'read_7_2_6',
            }, {
                title: '编辑',
                key: 'edit_7_2_6',
            }]
        }, {
            title: `7.2.7 F&B 部门`,
            value: '/hr/7_2/F&B',
            key: '/hr/7_2/F&B',
            children: [{
                title: '查看',
                key: 'read_7_2_7',
            }, {
                title: '编辑',
                key: 'edit_7_2_7',
            }]
        }, {
            title: `7.2.8 S&M 部门`,
            value: '/hr/7_2/S&M',
            key: '/hr/7_2/S&M',
            children: [{
                title: '查看',
                key: 'read_7_2_8',
            }, {
                title: '编辑',
                key: 'edit_7_2_8',
            }]
        }, {
            title: `7.2.9 HR 组织的酒店公共课`,
            value: '/hr/7_2/HRPC',
            key: '/hr/7_2/HRPC',
            children: [{
                title: '查看',
                key: 'read_7_2_9',
            }, {
                title: '编辑',
                key: 'edit_7_2_9',
            }]
        }]
    }]
}, {
    title: `8.0 Case Studies <br/>案例分析`,
    value: '/hr/8',
    key: '/hr/8',
    children: [{
        title: '查看',
        key: 'read_8',
    }, {
        title: '编辑',
        key: 'edit_8',
    }]
},
// {
//     title: `9.0 Labor Cost and Productivity 人力成本及生产效率对比分析`,
//     value: '/hr/9',
//     key: '/hr/9',
//     children: [{
//         title: '查看',
//         key: 'read_9',
//     }, {
//         title: '编辑',
//         key: 'edit_9',
//     }]
// },
// 迁移至ES7.7
{
    title: `HR-已添加PDF列表`,
    value: '/hr/pdf',
    key: '/hr/pdf',
    children: [{
        title: '查看',
        key: 'read_pdf',
    }, {
        title: '编辑',
        key: 'edit_pdf',
    }]
}, {
    title: 'Business Plan 年度经营计划',
    value: '/bp',
    key: '/bp',
    children: [{
        title: '查看',
        key: 'read_bp',
    }, {
        title: '编辑',
        key: 'edit_bp',
    }]
}, {
    title: 'Executive Summary Report 月度经营报告',
    value: '/table',
    key: '/table',
    children: [{
        title: '查看',
        key: 'read_table',
    }, {
        title: '编辑',
        key: 'edit_table',
    }]
}]

export default authData;



// WEBPACK FOOTER //
// ./src/hr/user/data.js